import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ICONS} from 'src/app/constants/icons/icons.constants';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ''
})
export class IconsComponent {
    protected ICONS: typeof ICONS;

    public constructor() {
        this.ICONS = ICONS;
    }
}
